// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeleteRowOutlinedSvg from "@fishx/icons-svg/es/asn/DeleteRowOutlined";
import FishxIcon from '../components/FishxIcon';

var DeleteRowOutlined = function DeleteRowOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeleteRowOutlinedSvg
  }));
};

DeleteRowOutlined.displayName = 'DeleteRowOutlined';
export default React.forwardRef(DeleteRowOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DeleteRowOutlined.js
// module id = 2391
// module chunks = 0